'use strict';

angular.module('app.timeline', [])
    .factory('TimelineService', function ($rootScope) {
        var service = {};

        service.logTimeline = [
            { label: 'Today', value: 'today' },
            { label: 'Yesterday', value: 'yesterday' },
            { label: 'Last Week', value: 'last_week' },
            { label: 'Last Month', value: 'last_month' },
            { label: 'Current Month', value: 'current_month' }
        ];

        service.calculateDateRangeByLogTimeline = function (timeline) {
            switch (timeline) {
                case 'today':
                    return {
                        fromDate: moment().startOf('day').utc().format(),
                        toDate: moment().utc().format()
                    };
                case 'yesterday':
                    return {
                        fromDate: moment().add(-1, 'days').startOf('day').utc().format(),
                        toDate: moment().add(-1, 'days').endOf('day').utc().format()
                    };
                case 'last_week':
                    return {
                        fromDate: moment().add(-7, 'days').startOf('day').utc().format(),
                        toDate: moment().utc().format()
                    };
                case 'last_month':
                    return {
                        fromDate: moment().add(-1, 'months').startOf('month').utc().format(),
                        toDate: moment().add(-1, 'months').endOf('month').utc().format()
                    };
                case 'current_month':
                    return {
                        fromDate: moment().startOf('month').utc().format(),
                        toDate: moment().utc().format()
                    };
                default:
                    throw new Error('Unknown timeline: ' + timeline);
            }
        }

        return service;
    });